import { Tabs } from 'antd'
import React, { Children } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import {
  AccreditationNotificationKey,
  InspectionProcessKey,
  CreateNewCustomerKey,
  ListEditAccreditationKey,
  ListAccreditationKey,
  AccreditationStatisticalKey,
  ListReportStaistic,
  AccreditationSettingKey
} from 'constants/accreditationTabs';
import { routes } from 'App';
import NotPermission from 'components/NotPermission/NotPermission';
import { STATION_TYPES } from 'constants/station';
import AccreditationSetting from 'Page/Accreditation/AccreditationSetting';
import BasicTabs from 'components/BasicTabs';
import { ALL_PERMISSION } from 'constants/permission';
const { TabPane } = Tabs

const AccreditationTabs = ({
  children
}) => {
  const { t: translation } = useTranslation()
  const listTab = [{
    key: ListAccreditationKey,
    label :translation("accreditation.title"),
    permission: undefined,
    pathname: '/accreditation'
  },
  {
    key: ListEditAccreditationKey,
    label :translation("accreditation.list"),
    permission: undefined,
    pathname: '/list-detail-accreditation'
  },
  {
    key: InspectionProcessKey,
    label :translation("accreditation.inspectionProcess"),
    permission: undefined,
    pathname: '/inspection-process'

  },
  {
    key: AccreditationNotificationKey,
    label :translation("accreditation.accreditationNotification"),
    permission: undefined,
    pathname: '/accreditation-public',
    isBlankTab: true
  },
  {
    key: AccreditationStatisticalKey,
    label :translation("listCustomers.statistical"),
    permission: undefined,
    pathname: '/statistical-accreditation'
  },
  {
    key: ListReportStaistic,
    label :translation("accreditation.report_accreditation"),
    permission: undefined,
    pathname: '/list-report-accreditation'
  },
  {
    key: AccreditationSettingKey,
    label :translation("accreditation.setting"),
    permission: undefined,
    pathname: '/accreditation-setting',
    condition: [STATION_TYPES.MAIN_STATION]
  },
]
  return (
    <div>
      <BasicTabs tabs={listTab} permissionConstant={ALL_PERMISSION.MANAGE_RECORD.permissionTab} checkByPathname={true}/>
      {children}
    </div>
  )
}

export default AccreditationTabs
